var j = Object.defineProperty;
var C = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, L = Object.prototype.propertyIsEnumerable;
var N = (a, t, e) => t in a ? j(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e, x = (a, t) => {
  for (var e in t || (t = {}))
    D.call(t, e) && N(a, e, t[e]);
  if (C)
    for (var e of C(t))
      L.call(t, e) && N(a, e, t[e]);
  return a;
};
var M = (a, t, e) => new Promise((v, d) => {
  var h = (i) => {
    try {
      f(e.next(i));
    } catch (p) {
      d(p);
    }
  }, m = (i) => {
    try {
      f(e.throw(i));
    } catch (p) {
      d(p);
    }
  }, f = (i) => i.done ? v(i.value) : Promise.resolve(i.value).then(h, m);
  f((e = e.apply(a, t)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postRuleValidate as T } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import "@oppein/op-utils";
import { useLanguage as U } from "../../../../utils/useLanguage.js";
import { defineComponent as q, useTemplateRef as z, watch as k, computed as J, onMounted as K, openBlock as A, createElementBlock as G, createElementVNode as F, createVNode as s, withCtx as c, createTextVNode as S, Fragment as H } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as w, reactive as I, unref as l } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as P } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import Q from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import W from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import X from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import Y from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import Z from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import $ from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import ee from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import V from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import { toDisplayString as B } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import oe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const le = { style: { display: "flex", "justify-content": "center", gap: "8px", "margin-top": "16px" } }, ye = /* @__PURE__ */ q({
  __name: "lichen",
  props: {
    options: {},
    locale: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(a, { expose: t, emit: e }) {
    const { i18n: v } = U(), { t: d } = v.global, h = z("lichenContainer"), m = w(null), f = P(), i = a;
    k(
      () => i.locale,
      (o) => {
        v.global.locale.value = o || "zh-CN";
      },
      { immediate: !0 }
    );
    const p = e, g = w(!1), b = w(!0), _ = w([]), n = I({
      liningModel: ""
    }), E = {
      liningModel: [{ required: !0, message: "请选择里衬型号", trigger: "blur" }]
    }, O = J(() => {
      const o = _.value.find((r) => r.code === "liningModel");
      return (o == null ? void 0 : o.values) || [];
    }), y = () => {
      var o;
      (o = m.value) == null || o.restoreValidation(), n.liningModel = "里衬型号a", p("hide-dialog");
    }, R = () => M(this, null, function* () {
      if (m.value)
        try {
          yield m.value.validate();
          const o = {
            liningModel: n.liningModel
          };
          g.value = !0;
          const r = yield T([
            {
              data: JSON.stringify(o),
              classificationCode: "FL_lichen"
            }
          ]);
          g.value = !1, r.status ? (f.success("操作成功"), p("onSuccess", x({}, n))) : f.error(r.message || "操作失败，请检查输入项");
        } catch (o) {
          g.value = !1, console.error("提交失败:", o);
        }
    });
    return k(
      () => i.options,
      (o) => {
        Object.keys(n).forEach((r) => {
          const u = r;
          o[u] !== void 0 && (n[u] = o[u] || n[u]);
        }), _.value.push({
          code: "liningModel",
          values: [{ value: "里衬型号a", valueCode: "里衬型号a" }]
        });
      },
      { immediate: !0, deep: !0 }
    ), K(() => {
    }), t({
      lichenForm: m,
      loading: g,
      isShowDialog: b,
      formData: n
    }), (o, r) => (A(), G(H, null, [
      F("div", {
        ref_key: "lichenContainer",
        ref: h
      }, null, 512),
      s(l(oe), {
        bordered: "",
        show: b.value,
        "onUpdate:show": r[1] || (r[1] = (u) => b.value = u),
        "mask-closable": !1,
        to: h.value || "body",
        class: "tw:!text-left"
      }, {
        default: c(() => [
          s(l(Q), {
            class: "tw:!w-[50%] tw:!box-border tw:!text-left",
            title: l(d)("里衬"),
            bordered: !1,
            role: "dialog",
            closable: "",
            "header-class": "tw:!text-center",
            onClose: y
          }, {
            default: c(() => [
              s(l(W), { show: g.value }, {
                default: c(() => [
                  s(l(X), {
                    model: n,
                    rules: E,
                    ref_key: "lichenForm",
                    ref: m,
                    "label-placement": "left",
                    "label-width": "80px",
                    class: "op-clear"
                  }, {
                    default: c(() => [
                      s(l(Y), null, {
                        default: c(() => [
                          s(l(Z), { span: 24 }, {
                            default: c(() => [
                              s(l($), {
                                label: l(d)("里衬型号"),
                                path: "liningModel"
                              }, {
                                default: c(() => [
                                  s(l(ee), {
                                    value: n.liningModel,
                                    "onUpdate:value": r[0] || (r[0] = (u) => n.liningModel = u),
                                    placeholder: l(d)("请选择里衬型号"),
                                    options: O.value,
                                    "label-field": "value",
                                    "value-field": "valueCode",
                                    "key-field": "valueCode",
                                    class: "tw:!w-[50%] tw:!text-left",
                                    to: !1
                                  }, null, 8, ["value", "placeholder", "options"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      F("div", le, [
                        s(l(V), { onClick: y }, {
                          default: c(() => [
                            S(B(l(d)("取消")), 1)
                          ]),
                          _: 1
                        }),
                        s(l(V), {
                          type: "primary",
                          onClick: R
                        }, {
                          default: c(() => [
                            S(B(l(d)("确定")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ye as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/lichen/lichen.vue.js
// module id = 1265
// module chunks = 67